const RadioView = ({ label, value = false, checkPosition = "left" }) => {
  return (
    <div className="my-4 flex items-center gap-2">
      {checkPosition === "left" && <input type="radio" checked={value} />}
      <label className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
        {label}
      </label>
      {checkPosition === "right" && <input type="radio" checked={value} />}
    </div>
  );
};

export default RadioView;
